var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyVacancies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08335 7.49999C8.69418 7.49999 10 6.19415 10 4.58332C10 2.97249 8.69418 1.66666 7.08335 1.66666C5.47252 1.66666 4.16669 2.97249 4.16669 4.58332C4.16669 6.19415 5.47252 7.49999 7.08335 7.49999Z",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.3333H10.8333C10.3731 13.3333 10 13.6531 10 14.0476V17.619C10 18.0135 10.3731 18.3333 10.8333 18.3333H17.5C17.9602 18.3333 18.3333 18.0135 18.3333 17.619V14.0476C18.3333 13.6531 17.9602 13.3333 17.5 13.3333Z",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 15L14.1667 15.8333L10 15",
    stroke: "#1976D2",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 13.3333V11.8518C15.4167 11.8027 15.3508 11.7556 15.2336 11.7209C15.1164 11.6862 14.9574 11.6667 14.7917 11.6667H13.5417C13.3759 11.6667 13.217 11.6862 13.0997 11.7209C12.9825 11.7556 12.9167 11.8027 12.9167 11.8518V13.3333",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9955 10.6509C10.5657 10.2341 9.98279 10 9.375 10H4.79167C4.18388 10 3.60098 10.2341 3.17121 10.6509C2.74144 11.0676 2.5 11.6329 2.5 12.2222V14.1667",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyVacancies);
export default __webpack_public_path__ + "static/media/my_vacancies.bbd68ec1312762a65c47ca3981f36fd5.svg";
export { ForwardRef as ReactComponent };